import { useEffect, useRef, useState } from "react";

// ─── Data ────────────────────────────────────────────────────────────────────
const WORLD = [
  { id: "dubai", name: "Dubai", sub: "UAE", lat: 25.2, lon: 55.27 },
  { id: "abudhabi", name: "Abu Dhabi", sub: "UAE", lat: 24.45, lon: 54.37 },
  { id: "sharjah", name: "Sharjah", sub: "UAE", lat: 25.35, lon: 55.42 },
  { id: "ajman", name: "Ajman", sub: "UAE", lat: 25.4, lon: 55.44 },
  { id: "rak", name: "Ras Al Khaimah", sub: "UAE", lat: 25.78, lon: 55.94 },
  { id: "cairo", name: "Cairo", sub: "Egypt", lat: 30.04, lon: 31.23 },
  { id: "lagos", name: "Lagos", sub: "Nigeria", lat: 6.52, lon: 3.37 },
  { id: "capetown", name: "Cape Town", sub: "S. Africa", lat: -33.92, lon: 18.42 },
  { id: "london", name: "London", sub: "UK", lat: 51.5, lon: -0.12 },
  { id: "paris", name: "Paris", sub: "France", lat: 48.85, lon: 2.35 },
  { id: "berlin", name: "Berlin", sub: "Germany", lat: 52.52, lon: 13.4 },
];

const INDIA = [
  { id: "delhi", name: "Delhi", lat: 28.61, lon: 77.2 },
  { id: "mumbai", name: "Mumbai", lat: 19.07, lon: 72.87 },
  { id: "kolkata", name: "Kolkata", lat: 22.57, lon: 88.36 },
  { id: "chennai", name: "Chennai", lat: 13.08, lon: 80.27 },
  { id: "bengaluru", name: "Bengaluru", lat: 12.97, lon: 77.59 },
  { id: "hyderabad", name: "Hyderabad", lat: 17.38, lon: 78.48 },
  { id: "pune", name: "Pune", lat: 18.52, lon: 73.85 },
  { id: "ahmedabad", name: "Ahmedabad", lat: 23.02, lon: 72.57 },
  { id: "jaipur", name: "Jaipur", lat: 26.91, lon: 75.78 },
  { id: "lucknow", name: "Lucknow", lat: 26.84, lon: 80.94 },
  { id: "bhopal", name: "Bhopal", lat: 23.25, lon: 77.41 },
  { id: "patna", name: "Patna", lat: 25.59, lon: 85.13 },
  { id: "chandigarh", name: "Chandigarh", lat: 30.73, lon: 76.77 },
  { id: "kochi", name: "Kochi", lat: 9.93, lon: 76.26 },
  { id: "guwahati", name: "Guwahati", lat: 26.14, lon: 91.73 },
  { id: "srinagar", name: "Srinagar", lat: 34.08, lon: 74.79 },
  { id: "bhubaneswar", name: "Bhubaneswar", lat: 20.29, lon: 85.82 },
  { id: "indore", name: "Indore", lat: 22.71, lon: 75.85 },
  { id: "thiruvananthapuram", name: "Thiruvananthapuram", lat: 8.52, lon: 76.93 },
];

const KA = [
  { id: "blr_urban", name: "Bangalore Urban", lat: 12.97, lon: 77.59, major: true },
  { id: "blr_rural", name: "Bangalore Rural", lat: 13.19, lon: 77.63, major: true },
  { id: "ramanagara", name: "Ramanagara", lat: 12.71, lon: 77.28 },
  { id: "mysore", name: "Mysore", lat: 12.29, lon: 76.63, major: true },
  { id: "mandya", name: "Mandya", lat: 12.52, lon: 76.89 },
  { id: "chamarajanagar", name: "Chamarajanagar", lat: 11.92, lon: 76.94 },
  { id: "hassan", name: "Hassan", lat: 13.0, lon: 76.1 },
  { id: "kodagu", name: "Kodagu", lat: 12.42, lon: 75.73 },
  { id: "dakshina_kannada", name: "Dakshina Kannada", lat: 12.87, lon: 74.88, major: true },
  { id: "udupi", name: "Udupi", lat: 13.34, lon: 74.74 },
  { id: "uttara_kannada", name: "Uttara Kannada", lat: 14.81, lon: 74.13 },
  { id: "shimoga", name: "Shimoga", lat: 13.92, lon: 75.56, major: true },
  { id: "chikmagalur", name: "Chikmagalur", lat: 13.31, lon: 75.77 },
  { id: "tumkur", name: "Tumkur", lat: 13.33, lon: 77.1 },
  { id: "chitradurga", name: "Chitradurga", lat: 14.22, lon: 76.39 },
  { id: "davangere", name: "Davangere", lat: 14.46, lon: 75.92 },
  { id: "haveri", name: "Haveri", lat: 14.79, lon: 75.4 },
  { id: "gadag", name: "Gadag", lat: 15.43, lon: 75.62 },
  { id: "dharwad", name: "Dharwad", lat: 15.45, lon: 75.0, major: true },
  { id: "belagavi", name: "Belagavi", lat: 15.84, lon: 74.49, major: true },
  { id: "bagalkot", name: "Bagalkot", lat: 16.18, lon: 75.69 },
  { id: "vijayapura", name: "Vijayapura", lat: 16.83, lon: 75.71 },
  { id: "kalaburagi", name: "Kalaburagi", lat: 17.32, lon: 76.83, major: true },
  { id: "bidar", name: "Bidar", lat: 17.91, lon: 77.52 },
  { id: "raichur", name: "Raichur", lat: 16.2, lon: 77.36 },
  { id: "koppal", name: "Koppal", lat: 15.34, lon: 76.15 },
  { id: "bellary", name: "Bellary", lat: 15.13, lon: 76.92 },
  { id: "vijayanagara", name: "Vijayanagara", lat: 15.27, lon: 76.38 },
  { id: "yadgir", name: "Yadgir", lat: 16.76, lon: 77.13 },
  { id: "kolar", name: "Kolar", lat: 13.13, lon: 78.12 },
  { id: "chikkaballapur", name: "Chikkaballapur", lat: 13.43, lon: 77.72 },
];


const PHASES = {
  WORLD: { dur: 9000, label: "🌍 Worldwide", ui: "world", color: "#a4d2ff" },
  TO_INDIA: { dur: 4500, label: "🇮🇳 Across India", ui: "india", color: "#fca311" },
  INDIA: { dur: 5500, label: "🇮🇳 Across India", ui: "india", color: "#fca311" },
  TO_KA: { dur: 4500, label: "📍 Karnataka", ui: "karnataka", color: "#e63946" },
  KA: { dur: 9000, label: "📍 Karnataka", ui: "karnataka", color: "#e63946" },
};

const smoothDamp = (current, target, velocityRef, smoothTime, delta) => {
  const omega = 2 / smoothTime;
  const x = omega * delta;
  const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);

  let change = current - target;

  const temp = (velocityRef.current + omega * change) * delta;

  velocityRef.current = (velocityRef.current - omega * temp) * exp;

  return target + (change + temp) * exp;
};

export default function GlobeReach() {
  const canvasRef = useRef(null);
  const wrapRef = useRef(null);
  const rafRef = useRef(null);

  const lonVel = useRef(0);
  const latVel = useRef(0);
  const scaleVel = useRef(0);

  const stateRef = useRef({
    rot: [-20, -15],
    scale: 0,
    phase: "WORLD",
    phaseStart: 0,
    prevTs: 0,
    geo50: null,
    d3: null,
    topo: null,
  });

  const [uiPhase, setUiPhase] = useState("world");
  const [phaseColor, setPhaseColor] = useState("#a4d2ff");
  const [phaseLabel, setPhaseLabel] = useState("🌍 Worldwide");

  useEffect(() => {
    const loadScript = src =>
      new Promise((res, rej) => {
        if (document.querySelector(`script[src="${src}"]`)) return res();

        const s = document.createElement("script");
        s.src = src;
        s.crossOrigin = "anonymous";
        s.onload = res;
        s.onerror = rej;

        document.head.appendChild(s);
      });

    Promise.all([
      loadScript("https://cdn.jsdelivr.net/npm/d3@7/dist/d3.min.js"),
      loadScript("https://cdnjs.cloudflare.com/ajax/libs/topojson/3.0.2/topojson.min.js"),
    ])
      .then(() => {
        stateRef.current.d3 = window.d3;
        stateRef.current.topo = window.topojson;

        return fetch(
          "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json"
        ).then(r => {
          if (!r.ok) throw new Error(`HTTP error ${r.status}`);
          return r.json();
        });
      })
      .then(world50 => {
        const topo = stateRef.current.topo;

        stateRef.current.geo50 = topo.feature(
          world50,
          world50.objects.countries
        );

        startLoop();
      })
      .catch(err => {
        console.error("Globe scripts/data loading error:", err);
      });

    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  function startLoop() {
    const st = stateRef.current;

    const PHASE_ORDER = ["WORLD", "TO_INDIA", "INDIA", "TO_KA", "KA"];

    const nextPhase = current => {
      const idx = PHASE_ORDER.indexOf(current);
      return PHASE_ORDER[(idx + 1) % PHASE_ORDER.length];
    };

    const getBase = () => {
      const el = wrapRef.current;

      if (!el) return 180;

      return Math.min(el.clientWidth, el.clientHeight) * 0.42;
    };

    st.scale = getBase();
    st.phaseStart = performance.now();

    const TARGET = {
      TO_INDIA: {
        rot: [-78, -21],
        scale: () => getBase() * 1.4,
      },

      TO_KA: {
        rot: [-76.2, -14.2],
        scale: () => getBase() * 6.5,
      },
    };

    function frame(ts) {
      rafRef.current = requestAnimationFrame(frame);

      const canvas = canvasRef.current;
      const wrap = wrapRef.current;

      if (!canvas || !wrap) return;

      const { d3, geo50 } = st;

      if (!d3) return;

      const delta = Math.min((ts - (st.prevTs || ts)) / 1000, 0.032);

      st.prevTs = ts;

      const W = wrap.clientWidth;
      const H = wrap.clientHeight;

      const dpr = window.devicePixelRatio || 1;

      if (canvas.width !== W * dpr || canvas.height !== H * dpr) {
        canvas.width = W * dpr;
        canvas.height = H * dpr;

        canvas.style.width = W + "px";
        canvas.style.height = H + "px";
      }

      const elapsed = ts - st.phaseStart;

      if (st.phase === "WORLD") {
        st.rot[0] -= 0.12 * (delta * 60);

        if (elapsed > PHASES.WORLD.dur) {
          st.phase = nextPhase("WORLD");
          st.phaseStart = ts;

          setUiPhase("india");
          setPhaseColor("#fca311");
          setPhaseLabel("🇮🇳 Across India");
        }
      }

      else if (st.phase === "TO_INDIA") {
        st.rot[0] = smoothDamp(
          st.rot[0],
          TARGET.TO_INDIA.rot[0],
          lonVel,
          0.55,
          delta
        );

        st.rot[1] = smoothDamp(
          st.rot[1],
          TARGET.TO_INDIA.rot[1],
          latVel,
          0.55,
          delta
        );

        st.scale = smoothDamp(
          st.scale,
          TARGET.TO_INDIA.scale(),
          scaleVel,
          0.7,
          delta
        );

        if (elapsed > PHASES.TO_INDIA.dur) {
          st.phase = nextPhase("TO_INDIA");
          st.phaseStart = ts;
        }
      }

      else if (st.phase === "INDIA") {
        st.rot[0] -= 0.03 * (delta * 60);

        if (elapsed > PHASES.INDIA.dur) {
          st.phase = nextPhase("INDIA");
          st.phaseStart = ts;

          setUiPhase("karnataka");
          setPhaseColor("#e63946");
          setPhaseLabel("📍 Karnataka");
        }
      }

      else if (st.phase === "TO_KA") {
        st.rot[0] = smoothDamp(
          st.rot[0],
          TARGET.TO_KA.rot[0],
          lonVel,
          0.65,
          delta
        );

        st.rot[1] = smoothDamp(
          st.rot[1],
          TARGET.TO_KA.rot[1],
          latVel,
          0.65,
          delta
        );

        st.scale = smoothDamp(
          st.scale,
          TARGET.TO_KA.scale(),
          scaleVel,
          0.8,
          delta
        );

        if (elapsed > PHASES.TO_KA.dur) {
          st.phase = nextPhase("TO_KA");
          st.phaseStart = ts;
        }
      }

      else if (st.phase === "KA") {
        st.rot[0] -= 0.004 * (delta * 60);

        if (elapsed > PHASES.KA.dur) {
          st.phase = nextPhase("KA");
          st.phaseStart = ts;

          st.rot = [-20, -15];
          st.scale = getBase();

          setUiPhase("world");
          setPhaseColor("#a4d2ff");
          setPhaseLabel("🌍 Worldwide");
        }
      }

      const ctx = canvas.getContext("2d");

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      ctx.clearRect(0, 0, W, H);

      const cx = W / 2;
      const cy = H / 2;

      const proj = d3
        .geoOrthographic()
        .scale(st.scale)
        .translate([cx, cy])
        .rotate([st.rot[0], st.rot[1], 0])
        .clipAngle(90);

      const path = d3.geoPath().projection(proj).context(ctx);

      ctx.beginPath();
      path({ type: "Sphere" });

      const ocean = ctx.createRadialGradient(
        cx,
        cy,
        st.scale * 0.2,
        cx,
        cy,
        st.scale
      );

      ocean.addColorStop(0, "#0b1f3a");
      ocean.addColorStop(1, "#020611");

      ctx.fillStyle = ocean;
      ctx.fill();

      if (geo50) {
        ctx.beginPath();
        path(geo50);

        ctx.fillStyle = "#1d4b37";
        ctx.fill();

        ctx.strokeStyle = "#3f7f5f";
        ctx.lineWidth = 0.5;
        ctx.stroke();
      }

      const renderMarker = (lat, lon, color, label) => {
        const p = proj([lon, lat]);

        if (!p) return;

        const [x, y] = p;

        ctx.beginPath();

        ctx.arc(x, y, 4, 0, Math.PI * 2);

        ctx.fillStyle = color;
        ctx.fill();

        ctx.shadowColor = color;
        ctx.shadowBlur = 12;

        ctx.beginPath();

        ctx.arc(x, y, 4, 0, Math.PI * 2);

        ctx.fill();

        ctx.shadowBlur = 0;

        if (st.scale > 180) {
          ctx.fillStyle = "#fff";
          ctx.font = "11px DM Sans";
          ctx.fillText(label, x + 8, y - 4);
        }
      };

      if (["WORLD", "TO_INDIA"].includes(st.phase)) {
        WORLD.forEach(m =>
          renderMarker(m.lat, m.lon, "#a4d2ff", m.name)
        );
      }

      if (["TO_INDIA", "INDIA", "TO_KA"].includes(st.phase)) {
        INDIA.forEach(m =>
          renderMarker(m.lat, m.lon, "#fca311", m.name)
        );
      }

      if (["TO_KA", "KA"].includes(st.phase)) {
        KA.forEach(m =>
          renderMarker(m.lat, m.lon, "#e63946", m.name)
        );
      }
    }

    requestAnimationFrame(frame);
  }

  const tagData = {
    world: { locs: WORLD, key: l => `${l.name}, ${l.sub}` },
    india: { locs: INDIA, key: l => l.name },
    karnataka: { locs: KA, key: l => l.name },
  };

  const cur = tagData[uiPhase];

  return (
    <div
      className="relative flex flex-col items-center justify-start overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse at top, #111a28 0%, #030811 100%)",
        minHeight: "100vh",
        padding: "32px 16px",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

        @keyframes pulse-dot {
          0%,100% { opacity:1; transform:scale(1) }
          50% { opacity:.4; transform:scale(.65) }
        }

        .globe-glow {
          filter: drop-shadow(0 0 45px rgba(92,164,255,0.15));
        }
      `}</style>

      <div
        className="flex items-center gap-2 px-4 py-1.5 rounded-full mb-6"
        style={{
          border: "1px solid rgba(255,255,255,0.15)",
          background: "rgba(255,255,255,0.05)",
          backdropFilter: "blur(8px)",
        }}
      >
        <div
          className="w-2 h-2 rounded-full"
          style={{
            background: phaseColor,
            animation: "pulse-dot 2s ease-in-out infinite",
          }}
        />

        <span
          style={{
            color: "#fff",
            fontSize: 11,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
          }}
        >
          Global Reach
        </span>
      </div>

      <h1
        style={{
          fontFamily: "'Syne',sans-serif",
          fontWeight: 800,
          textAlign: "center",
          fontSize: "clamp(32px,6vw,64px)",
          color: "#fff",
        }}
      >
        We have students
      </h1>

      <h1
        style={{
          fontFamily: "'Syne',sans-serif",
          fontWeight: 800,
          textAlign: "center",
          fontSize: "clamp(32px,6vw,64px)",
          background: `linear-gradient(90deg, ${phaseColor} 0%, #fff 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        From
      </h1>

      <div
        ref={wrapRef}
        className="globe-glow relative z-10"
        style={{
          width: "min(90vw, 550px)",
          aspectRatio: "1/1",
          margin: "10px 0",
        }}
      >
        <canvas
          ref={canvasRef}
          style={{
            display: "block",
            width: "100%",
            height: "100%",
          }}
        />
      </div>

      <div
        className="text-sm mt-3 mb-5 font-semibold uppercase"
        style={{
          color: phaseColor,
          letterSpacing: "0.1em",
        }}
      >
        {phaseLabel}
      </div>

      <div className="flex flex-wrap justify-center gap-2 max-w-4xl px-4">
        {cur.locs.map(l => (
          <span
            key={l.id}
            className="text-xs px-3 py-1 rounded-full"
            style={{
              border: `1px solid ${phaseColor}55`,
              background: `${phaseColor}15`,
              color: "#fff",
            }}
          >
            📍 {cur.key(l)}
          </span>
        ))}
      </div>
    </div>
  );
}